import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import CustomButtonAdmin from "./CustomButtonAdmin";
import theme from "../../theme";

export function DialogEliminar({ element, onClick, setOpen, open, loading = false }) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            disableScrollLock
            maxWidth="md"
        >
            <DialogTitle sx={{ background: theme.color.primary, color: "white" }}>Eliminar {element}</DialogTitle>
            <DialogContent>
                <Typography mt={8} variant="body1">
                    Segur que ho vols eliminar?
                </Typography>
            </DialogContent>
            <DialogActions>
                <CustomButtonAdmin onClick={() => setOpen(false)} title={"Cancel·lar"} fullWidth loading={loading} />
                <CustomButtonAdmin onClick={onClick} title={"Eliminar"} danger fullWidth loading={loading} />
            </DialogActions>
        </Dialog>
    );
}
